import React, { useRef, useEffect } from 'react';

const mDefault = {
  sap: '23895-Gainsville',
  rad: 30000,
  loChord: 19000,
  upChord: 18600,
  ht: 11335,
  smile: 590,
  frown: 100,
  bpl: 300,
  bays: 7,
  layers: [2, 2, 1, 2, 2, 0.5],
  shakerRows: 4,
  shakerOffset: 0,
};

let m = mDefault;

const FrameCanvas = (props) => {
  const items = props.params;
  const canvasRef = useRef(null);
  let scaleF = 1.0;
  let xOff = 0.0;
  let yOffFront = 0.0;

  useEffect(() => {
    const canvasFront = canvasRef.current;

    if (canvasFront) {
      const ctxTower = canvasFront.getContext('2d');
      // ctxTower.fillRect(0, 0, 500, 500);

      updateModel(ctxTower, canvasFront);
      setScale(canvasFront);
      xOff = canvasFront.width * 0.5;
      yOffFront = canvasFront.height;

      drawFrame(ctxTower);
      drawSpeaker(ctxTower);
      drawTowers(ctxTower);
    }
  }, [items]);

  function updateModel(ctx, canv) {
    // console.log(items[0].value);
    m.sap = items[0].value;
    m.rad = items[1].value;
    m.loChord = items[2].value;
    m.upChord = items[3].value;
    m.ht = items[4].value;
    m.smile = items[5].value;
    m.frown = items[6].value;
    m.bpl = items[7].value;
    m.bays = items[8].value;
    m.shakerRows = items[9].value;
    m.shakerOffset = items[10].value;
    const str = items[11].value;
    m.layers = str.split(',').map(Number);

    ctx.clearRect(0, 0, canv.width, canv.height);
  }

  function setScale(canv) {
    const cWidth = canv.width;
    const cHeight = canv.height;

    const scaleW = cWidth / (1.02 * m.loChord); // add 2% for border
    const scaleH = cHeight / (1.02 * (m.ht + m.bpl));

    scaleF = Math.min(scaleW, scaleH);
  }

  function cPoint(thePt) {
    const [x, y] = thePt;
    return [x * scaleF + xOff, yOffFront - y * scaleF];
  }

  function drawFrame(ctxTower) {
    //draw outside frame
    const sTL = [-0.5 * m.upChord, m.bpl + m.ht - m.frown];
    const sTC = [0, m.bpl + m.ht];
    const sTR = [0.5 * m.upChord, m.bpl + m.ht - m.frown];
    const sBR = [0.5 * m.loChord, m.bpl + m.smile];
    const sBC = [0, m.bpl];
    const sBL = [-0.5 * m.loChord, m.bpl + m.smile];
    ctxTower.beginPath();
    ctxTower.moveTo(...cPoint(sTL));
    ctxTower.lineTo(...cPoint(sTC));
    ctxTower.lineTo(...cPoint(sTR));
    ctxTower.lineTo(...cPoint(sBR));
    ctxTower.lineTo(...cPoint(sBC));
    ctxTower.lineTo(...cPoint(sBL));
    ctxTower.lineTo(...cPoint(sTL));
    ctxTower.strokeStyle = 'blue';
    ctxTower.stroke();

    //draw mid support frame
    const mXoff = 625;
    const mYoff1 = 600;
    const mYoff2 = 400;
    const mTL = [sTL[0] + mXoff, sTC[1] - mYoff1];
    const mTR = [-mTL[0], mTL[1]];
    const mBR = [sBR[0] - mXoff, sBR[1] + mYoff2];
    const mBL = [-mBR[0], mBR[1]];
    ctxTower.beginPath();
    ctxTower.moveTo(...cPoint(mTL));
    ctxTower.lineTo(...cPoint(mTR));
    ctxTower.lineTo(...cPoint(mBR));
    ctxTower.lineTo(...cPoint(mBL));
    ctxTower.lineTo(...cPoint(mTL));
    ctxTower.strokeStyle = 'red';
    ctxTower.stroke();

    //draw inner support frame
    const iXoff = 1250;
    const iYoff1 = 900;
    const iYoff2 = 700;
    const iTL = [sTL[0] + iXoff, sTC[1] - iYoff1];
    const iTR = [-iTL[0], iTL[1]];
    const iBR = [sBR[0] - iXoff, sBR[1] + iYoff2];
    const iBL = [-iBR[0], iBR[1]];
    ctxTower.beginPath();
    ctxTower.moveTo(...cPoint(iTL));
    ctxTower.lineTo(...cPoint(iTR));
    ctxTower.lineTo(...cPoint(iBR));
    ctxTower.lineTo(...cPoint(iBL));
    ctxTower.lineTo(...cPoint(iTL));
    ctxTower.strokeStyle = 'green';
    ctxTower.stroke();
  }

  function drawSpeaker(ctxTower) {
    const spkrWd = 820;
    const spkrHt = 1170;
    const spkrCen = m.bpl + 0.5 * m.ht;

    const TL = [-0.5 * spkrWd, spkrCen + 0.5 * spkrHt];
    const TR = [0.5 * spkrWd, spkrCen + 0.5 * spkrHt];
    const BR = [0.5 * spkrWd, spkrCen - 0.5 * spkrHt];
    const BL = [-0.5 * spkrWd, spkrCen - 0.5 * spkrHt];
    ctxTower.beginPath();
    ctxTower.moveTo(...cPoint(TL));
    ctxTower.lineTo(...cPoint(TR));
    ctxTower.lineTo(...cPoint(BR));
    ctxTower.lineTo(...cPoint(BL));
    ctxTower.lineTo(...cPoint(TL));
    ctxTower.strokeStyle = 'orange';
    ctxTower.fill();
  }

  function drawTowers(ctxTower) {
    const towerOff = 248.55; //tower offset from perimeter
    const bayWidth = 2400;
    const firstPlatform = 150;

    let towers = m.bays;

    const towerRad = m.rad + towerOff;
    const bayArc = 2 * Math.asin((0.5 * bayWidth) / towerRad);

    let towerHt = firstPlatform;
    for (let i = 0; i < m.layers.length; i++) {
      towerHt += 1000.0 * m.layers[i];
    }

    towerHt += 1600; //for the top

    //compute pt array for front
    const xTower = [];
    let ang = -0.5 * towers * bayArc;
    if (m.bays % 2 === 0) {
      xTower.push(towerRad * Math.sin(ang));
      ang += 0.5 * bayArc;
      towers -= 1;
    }
    for (let i = 0; i <= towers; i++) {
      xTower.push(towerRad * Math.sin(ang));
      ang += bayArc;
    }
    if (m.bays % 2 === 0) {
      ang -= 0.5 * bayArc;
      xTower.push(towerRad * Math.sin(ang));
    }
    ctxTower.strokeStyle = 'black';
    for (let i = 0; i < xTower.length; i++) {
      ctxTower.beginPath();
      ctxTower.moveTo(...cPoint([xTower[i], 0.0]));
      ctxTower.lineTo(...cPoint([xTower[i], towerHt]));
      ctxTower.stroke();
    }

    //draw the platforms

    const xMin = xTower[0];
    const xMax = xTower.at(-1);
    ctxTower.beginPath();
    ctxTower.moveTo(...cPoint([xMin, firstPlatform]));
    ctxTower.lineTo(...cPoint([xMax, firstPlatform]));
    ctxTower.stroke();

    let platHt = firstPlatform;
    for (let i = 0; i <= m.layers.length - 1; i++) {
      platHt += 1000.0 * m.layers[i];
      ctxTower.beginPath();
      ctxTower.moveTo(...cPoint([xMin, platHt]));
      ctxTower.lineTo(...cPoint([xMax, platHt]));
      ctxTower.stroke();
    }

    //draw shakers
    const shakerRad = 100 * scaleF;
    const shakerXoffset = 500;
    const shakerSpace = 2400;

    ctxTower.strokeStyle = 'black';
    ctxTower.fillStyle = 'blue';

    let xShak = 0.0;
    let shakerHt =
      m.bpl +
      0.5 * m.ht -
      shakerSpace * (0.5 * m.shakerRows - 0.5) +
      m.shakerOffset;
    // if the number of bays is even don't put shakers in half bay
    let iMin = m.bays % 2 === 0 ? 1 : 0;
    let iMax = m.bays % 2 === 0 ? xTower.length - 1 : xTower.length;

    for (let j = 0; j < m.shakerRows; j++) {
      for (let i = iMin; i < iMax; i++) {
        if (xTower[i] < 0) {
          xShak = xTower[i] + shakerXoffset;
        } else {
          xShak = xTower[i] - shakerXoffset;
        }
        ctxTower.beginPath();
        ctxTower.arc(...cPoint([xShak, shakerHt]), shakerRad, 0, 2 * Math.PI);
        ctxTower.fill();
      }
      shakerHt += shakerSpace;
    }
  }

  return (
    <>
      <canvas ref={canvasRef} width="1000px" height="600px" />
    </>
  );
};

export default FrameCanvas;
